export default {
  "sidemenu.memberFilter.title": "会員絞り込みマスター",
  "memberFilter.list.export": "会員リストCSV出力",
};